import { Artist, Release, Service, NavItem, Event } from './types';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'Roster', path: '/artists' },
  { label: 'Discography', path: '/releases' },
  { label: 'Agency', path: '/services' },
  { label: 'Demos', path: '/demo' },
  { label: 'Contact', path: '/contact' },
];

export const ARTISTS: Artist[] = [
  {
    id: '1',
    name: 'FL3X',
    genre: 'Afro House / Tech / Latin',
    bio: 'Tribal rhythms meeting futuristic synthesis. Fusing organic percussions with tech-driven grooves for a global sonic journey.',
    image: 'https://i.scdn.co/image/ab6761610000e5eb1b95c9939a6897781d500a8c',
    instagram: 'https://www.instagram.com/djprod_fl3x/',
    spotify: 'https://open.spotify.com/intl-it/artist/22s75Dh1I88bqF4OPk8GEW?si=E7Q_IsOPTK6YEhIn7Nz4XQ',
    spotifyId: '22s75Dh1I88bqF4OPk8GEW',
    epk: 'https://www.dropbox.com/scl/fi/4mz6myhyh22o0e6mvaig0/FL3X-EPK.pdf?rlkey=d8aun43dmqx3rtmjntag0839c&e=2&st=yy8mv47d&dl=0'
  },
  {
    id: '2',
    name: 'HELLEN',
    genre: 'Hip-Hop / Drill / Reggaeton',
    bio: 'Urban grit meets astral polish. Hard-hitting flows and rhythmic complexity from the dark side of the moon.',
    image: 'https://i.postimg.cc/7ZVZ2C3h/channels4-profile.jpg',
    instagram: 'https://www.instagram.com/therealhellen/$0',
    spotify: 'https://open.spotify.com/intl-it/artist/74FyYgGQplsaTN3j00skI5?si=mh1A3dcDRaucQN-qBa4j_w',
    spotifyId: '74FyYgGQplsaTN3j00skI5'
  },
  {
    id: '3',
    name: 'ANDREA ZELLETTA',
    genre: 'Electronic Commercial',
    bio: 'Mainstage energy with a sophisticated edge. Crafting high-impact anthems for the neon generation.',
    image: 'https://i.postimg.cc/wjHBM5mm/ab6761610000e5ebc801d0298800a7cd1760ab82.jpg',
    instagram: 'https://www.instagram.com/iamandreazelletta/?hl=it$0',
    spotify: 'https://open.spotify.com/intl-it/artist/2sSVegHvvHIOT1gVsqw8EW?si=vXZnPFJzT1aUB4IxzDA5DA',
    spotifyId: '2sSVegHvvHIOT1gVsqw8EW'
  },
  {
    id: '4',
    name: 'VALERIA PANZA',
    genre: 'Afro House',
    bio: 'Deep, spiritual grooves that transcend the dancefloor. The heartbeat of the cosmos tailored for the soul.',
    image: 'https://i.postimg.cc/3wfrtPbW/IMG-5513.jpg',
    instagram: 'https://www.instagram.com/valeriapanzadj/$0',

  },
  {
    id: '5',
    name: 'ETEREA',
    genre: 'House / Minimal Tech',
    bio: 'Stripped back, hypnotic, and pure. Essential frequencies and microscopic details for the dedicated listener.',
    image: 'https://i.postimg.cc/T3GP1jDb/b96eb798-eefd-41f3-a12d-6eb8de04b66d-jpg.webp',
    instagram: 'https://www.instagram.com/etereadj/$0',
    spotify: 'https://open.spotify.com/intl-it/artist/1O9hYMiYnPNz61a4GynrVZ?si=AUJTWSbCSL6OaJ79I56LJw',
    spotifyId: '1O9hYMiYnPNz61a4GynrVZ'
  },
  {
    id: '6',
    name: 'GIULIA PAUSELLI',
    genre: 'Deep House / Deep Techno',
    bio: 'Submerged basslines and emotional atmospheres. Diving deep into the abyss of sound where melody meets darkness.',
    image: 'https://i.postimg.cc/8CXLgkzq/STUDIO-1.jpg',
    instagram: 'https://www.instagram.com/la_pauselli/?hl=it$0',
    
  }
];

export const RELEASES: Release[] = [];

export const SERVICES: Service[] = [
  {
    id: 'srv_mix',
    title: 'Professional Mix',
    description: 'Transform your raw tracks into a polished, club-ready sonic experience with our hybrid analog/digital workflow.',
    detailedDescription: 'Our mixing engineers specialize in electronic music, understanding the nuances of low-end theory and spatial dimension. We treat every stem with surgical precision while maintaining the musical soul of your production. Using high-end outboard gear combined with industry-standard plugins, we deliver mixes that translate perfectly from headphones to festival systems.',
    price: '€75',
    features: [
      'Hybrid Analog/Digital Processing',
      'Vocal Tuning & Correction',
      'Creative FX & Automation',
      'Stem Mixing Available',
      '3 Revisions Included'
    ],
    icon: 'Sliders'
  },
  {
    id: 'srv_master',
    title: 'Professional Master',
    description: 'The final polish. Competitive loudness, tonal balance, and dynamic control for all streaming platforms.',
    detailedDescription: 'Mastering is the art of compromise and enhancement. We ensure your track stands up against top-tier commercial releases in volume and clarity without sacrificing dynamics. We provide masters optimized for Spotify, Apple Music, and Club Play (Extended Headroom).',
    price: '€60',
    features: [
      'Analog Saturation & Warmth',
      'Stereo Imaging Enhancement',
      'Loudness Optimization (LUFS)',
      'Streaming & Club Versions',
      'Apple Digital Master Ready'
    ],
    icon: 'Layers'
  },
  {
    id: 'srv_prod',
    title: 'Music Production',
    description: 'Full-service production assistance, from ghost production to co-production and arrangement help.',
    detailedDescription: 'Stuck on a loop? Need a professional drop? Our team of seasoned producers can help you finish your record. Whether you need ghost production to strictly match a reference track or a creative partner to co-produce and arrange your ideas, we bring your vision to life with industry-standard sound design.',
    price: 'Starting at €200',
    features: [
      'Custom Sound Design',
      'Arrangement & Structure',
      'Ghost Production (NDA signed)',
      'Remix Services',
      'Project File Delivery (Optional)'
    ],
    icon: 'Music2'
  },
  {
    id: 'srv_post',
    title: 'Post Production',
    description: 'Audio cleanup, sound design, and mixing for video content, podcasts, and cinematic projects.',
    detailedDescription: 'Visuals are only half the story. We provide cinematic sound design and post-production mixing for music videos, brand content, and films. We also offer dialogue cleanup and leveling for podcasts and interviews to ensure broadcast quality.',
    price: 'Starting at €50',
    features: [
      'Dialogue Denosing & Cleanup',
      'SFX & Foley Design',
      'Audio Logo Creation',
      'Video Sync & Mixing',
      'Broadcast Standards Compliance'
    ],
    icon: 'Film'
  },
  {
    id: 'srv_feed',
    title: 'Pro Feedback',
    description: 'Detailed, objective analysis of your track from signed artists and label A&Rs.',
    detailedDescription: 'Get an honest, constructive critique of your work before you submit it to labels. We analyze your mixdown, arrangement, sound selection, and overall vibe, providing actionable tips to improve the track. Stop guessing and get professional ears on your music.',
    price: '€25',
    features: [
      'Written PDF Report',
      'Mix & Balance Analysis',
      'Arrangement Suggestions',
      'Marketability Assessment',
      'Label Target Recommendations'
    ],
    icon: 'MessageSquare'
  },
  {
    id: 'srv_lesson',
    title: 'DJ Lessons',
    description: 'Master the art of DJing. From Rekordbox fundamentals to advanced 4-deck mixing techniques.',
    detailedDescription: 'Learn from active touring DJs. Whether you are a beginner looking to understand beatmatching or an advanced selector wanting to master harmonic mixing and loop manipulation, our tailored lessons will elevate your performance confidence.',
    price: '€20 / Hour',
    features: [
      'Rekordbox / CDJ-3000 Workflow',
      'Harmonic Mixing Theory',
      'Creative FX & Looping',
      'Set Curation & Flow',
      'In-Person (Berlin) or Zoom'
    ],
    icon: 'GraduationCap'
  }
];

export const EVENTS: Event[] = [];